import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute, Router, RouterLink } from "@angular/router";
import { Observable } from "rxjs";
import { ObservationService } from "../service/observation.service";

import { DateAdapter, MAT_DATE_FORMATS } from "@angular/material/core";
import {
  AppDateAdapter,
  APP_DATE_FORMATS,
} from "../../widget/date-picker/date-picker.component";
import { VariedadService } from "../../variedad/service/variedad.service";
import { FormsModule, ReactiveFormsModule, FormGroup, FormControl, Validators } from "@angular/forms";



import { WidgetService } from "../../widget/service/widget.service";
import { DialogDetailsComponent } from "../../widget/dialog-details/dialog-details.component";
import { MatDialog } from "@angular/material/dialog";
import { map, startWith } from "rxjs/operators";
import { DialogFormVarietyComponent } from "../../widget/dialog-form-variety/dialog-form-variety.component";
import { GuardianService } from "../../guardian/service/guardian.service";
import { AuthService } from "../../auth/service/auth.service";

export class VarietyItem {
  variety!: string;
  variety_id!: string;
  variety_name!: string;
}

export class FarmerItem {
  farmer_name!: string;
  birth_year!: number;
  sex!: string;
  full_farm_area!: number;
  farmer_id!: string;
}

@Component({
  selector: "app-observation-edit",
  templateUrl: "./observation-edit.component.html",
  styleUrls: ["./observation-edit.component.css"],
  providers: [
    { provide: DateAdapter, useClass: AppDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS },
  ],
})

export class ObservationEditComponent implements OnInit {
  @Input() id!: string | null;


  ageFormControl = new FormControl('');
  areaFormControl = new FormControl('');
  varietyObservationObject: any;
  _vs_id!: string;
  isChecked = true;
  date = new FormControl();
  chm_checked = false;
  search_farmer = false;
  varietyObservationObs!: Observable<any>;
  varietyObs!: Observable<any>;
  lastFarmerObs!: Observable<any>;
  varietyControl = new FormControl<string | VarietyItem>('', [Validators.required]);
  farmerControl = new FormControl<string | FarmerItem>('');
  filteredVarietyOptions!: Observable<string[]>;
  filteredFarmerOptions!: Observable<string[]>;

  variety_id!: string;
  farmer_id!: string;

  add_ini = 'Santa Elena';
  lat_ini = -18.2241131;
  lon_ini = -5.4472017;

  new_zoom = 1;
  zoom = 8;

  has_error_1 = false;
  has_error_2 = false;

  in_process = false;

  constructor(
    private observationService: ObservationService,
    private varietyService: VariedadService,
    private authService: AuthService,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    public farmerService: GuardianService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.filteredVarietyOptions = this.varietyControl.valueChanges
      .pipe(
        startWith(''),
        map(value => {
          const name = typeof value === 'string' ? value : value?.variety_name;
          return this._filter_variety(name as string);
        }),
      );

    this.filteredFarmerOptions = this.farmerControl.valueChanges
      .pipe(
        startWith(''),
        map(value => {
          const name = typeof value === 'string' ? value : value?.farmer_name;
          return this._filter_farmer(name as string);
        }),
      );
    this.getObservation(this.id);
    this.getLastFarmer();
  }

  private _filter_variety(variety_name: string | null): any[] {

    this.has_error_1 = false;

    const _variety_name = variety_name;
    const _optionList: any[] = [];
    const _var = {
      page: 0,
      page_size: 100,
      variety_name: _variety_name,
      country: null,
      region: null,
      varietal_group: null,
      original_only: false,
      is_original: null,
      user_id: null,
      created_date: null,
    };
    this.varietyService.getSearch(_var).subscribe((_obj: any) => {
      _obj.data.map((_data: any) => {
        const _varietyItem = {
          variety: _data.vs_id,
          variety_name: _data.variety_name,
          variety_id: _data.variety_id
        };
        _optionList.push(_varietyItem);
      });
    });
    return _optionList;
  }

  private _filter_farmer(farmer_name: string | null): any[] {
    const _farmer_name = farmer_name;
    const _optionList: any[] = [];
    this.farmerService.getSearch(farmer_name).subscribe((_obj: any) => {
      _obj.data.map((_farmer: FarmerItem) => {
        const _farmerItem = {
          farmer_name: _farmer.farmer_name,
          //age: (new Date().getFullYear() - _farmer?.birth_year).toString(),
          age: _farmer.birth_year,
          sex: _farmer.sex,
          full_farm_area: _farmer.full_farm_area,
          farmer_id: _farmer.farmer_id,
        };
        _optionList.push(_farmerItem);
      });
    });
    return _optionList;
  }

  getLastFarmer() {
    this.lastFarmerObs = this.farmerService.getLast();
  }

  fnGetAllFarmer() {
    if (this.search_farmer) {
      this.search_farmer = false;
    } else {
      this.search_farmer = true;
    }
  }

  getObservation(_id: string | null) {
    if (_id) {
      this.varietyObservationObs =
        this.observationService.getVarScoutObservation(_id);

      this.varietyObservationObs.subscribe((_obj: any) => {
        const _picture_list: {
          file_name: any;
          tag: any;
        }[] = [];

        _obj.data.pictures.map((_x: any) => {
          const _item = {
            file_name: _x.file_name,
            tag: _x.tag,
          };
          _picture_list.push(_item);
        });
        // se da formato a fecha
        const _date = _obj.data.date;
        const _format = _date?.length < 11 ? 'T05:00:00.000000Z' : '';
        const _date_format = _date + _format;
        // ----------------------
        this._vs_id = _obj.data.id;

        this.varietyObservationObject = {
          address: _obj.data.address,
          comment: _obj.data.comment,
          country: _obj.data.country,
          created: _obj.data.created,
          created_by: _obj.data.created_by,
          crop: _obj.data.crop,
          crop_name: _obj.data.crop_name,
          date: _date,
          display_name: _obj.data.display_name,
          effort: _obj.data.effort,
          estimated_planted_area: _obj.data.estimated_planted_area,
          estimated_planted_area_unit: _obj.data.estimated_planted_area_unit,
          existing_household_id: _obj.data.existing_household_id,
          household: {
            age: _obj.data.household?.age,
            anonymized: _obj.data.household?.anonymized,
            created_by: _obj.data.household?.created_by,
            full_farm_area: _obj.data.household?.full_farm_area,
            full_farm_area_unit: _obj.data.household?.full_farm_area_unit,
            growers_name: _obj.data.household?.growers_name,
            id: _obj.data.household?.id,
            modified_by: _obj.data.household?.modified_by,
            origin_id: _obj.data.household?.origin_id,
            sex: _obj.data.household?.sex,
          },
          pictures: _picture_list,
          id: _obj.data.id,
          location_lat: _obj.data.location_lat,
          location_lon: _obj.data.location_lon,
          percentage_of_planted_area: _obj.data.percentage_of_planted_area,
          production: _obj.data.production,
          variety: _obj.data.variety,
          variety_name: _obj.data.variety_name,
        };
        this.variety_id = _obj.data.variety_id;
        this.date.setValue(new Date(_date_format).toISOString());
        this.ageFormControl.setValue(_obj.data.household?.age);
        this.areaFormControl.setValue(_obj.data.household?.full_farm_area);

        const _variety_object = {
          variety: _obj.data.variety,
          variety_id: _obj.data.variety_id,
          variety_name: _obj.data.variety_name
        }

        this.varietyControl.setValue(_variety_object);


      });
    } else {
      this.zoom = this.new_zoom;

      this.varietyObservationObject = {
        id: null,
        address: this.add_ini,
        effort: null,
        estimated_planted_area: null,
        estimated_planted_area_unit: 'AC',
        planted_area_percentage: null,
        production: null,
        observation_notes: null,
        observation_date: null,
        variety_id: null,
        latitude: null,
        longitude: null,
        farmer_id: null,
        farmer: null,
        images: [],

        comment: '',
        country: null,
        created: null,
        created_by: null,
        crop: null,
        crop_name: null,
        date: null,
        display_name: null,
        existing_household_id: null,
        household: {
          age: null,
          anonymized: null,
          created_by: null,
          full_farm_area: null,
          full_farm_area_unit: null,
          growers_name: null,
          id: null,
          modified_by: null,
          origin_id: null,
          sex: null,
        },
        pictures: [],
        location_lat: this.lat_ini,
        location_lon: this.lon_ini,
        percentage_of_planted_area: 100,
        variety: null,
        variety_name: null,

      };

      const _date = new Date().toISOString();
      this.varietyObservationObject.date = _date.slice(0, 10);
      this.date.setValue(_date);
    }
  }

  displayFnVariety(_obj: VarietyItem): string {
    return _obj && _obj.variety_name ? _obj.variety_name : '';
  }

  displayFnFarmer(_obj: FarmerItem): string {
    return _obj && _obj.farmer_name ? _obj.farmer_name : '';
  }

  selectFarmer($event: any) {
    const _farmer = $event.option.value;
    this.varietyObservationObject.household.growers_name = _farmer.farmer_name;
    //this.ageFormControl.setValue((new Date().getFullYear() - _farmer?.birth_year).toString());
    this.ageFormControl.setValue(_farmer.birth_year);
    this.varietyObservationObject.household.sex = _farmer.sex;
    this.areaFormControl.setValue(_farmer.full_farm_area);
    this.farmer_id = _farmer.farmer_id;
  }

  fnGetLastFarmer() {
    if (this.lastFarmerObs) {
      this.lastFarmerObs.subscribe(
        (_resp) => {
          const _farmer: FarmerItem = {
            farmer_name: _resp.data.farmer_name,
            birth_year: _resp.data?.birth_year,
            sex: _resp.data.sex,
            full_farm_area: _resp.data.full_farm_area,
            farmer_id: _resp.data.farmer_id,
          }
          this.farmer_id = _resp.data.farmer_id;
          this.varietyObservationObject.household.growers_name = _farmer.farmer_name;
          this.ageFormControl.setValue((new Date().getFullYear() - _farmer?.birth_year).toString());
          this.varietyObservationObject.household.sex = _farmer.sex;
          this.areaFormControl.setValue(_farmer.full_farm_area.toString());
        }
      );
    }
  }

  updateAge($event: any) {
    this.varietyObservationObject.household.age = $event;
  }

  updateArea($event: any) {
    this.varietyObservationObject.household.full_farm_area = $event;
  }

  save() {

    this.in_process = true;

    if (this.id) {
      const _variety_selectedPut = this._vs_id;

      const _household = {
        growers_name: this.varietyObservationObject.household.growers_name,
        age: this.varietyObservationObject.household.age ? this.varietyObservationObject.household.age : 0,
        sex: this.varietyObservationObject.household.sex,
        full_farm_area: this.varietyObservationObject.household.full_farm_area,
        full_farm_area_unit: this.varietyObservationObject.household.full_farm_area_unit,
        anonymized: this.varietyObservationObject.household.anonymized,
      };

      const _varietyObservationScoutPut = {
        crop: this.varietyObservationObject.crop,
        variety: this.varietyObservationObject.variety,
        crop_name: this.varietyObservationObject.crop_name,
        estimated_planted_area: this.varietyObservationObject.estimated_planted_area,
        estimated_planted_area_unit: this.varietyObservationObject.estimated_planted_area_unit,
        percentage_of_planted_area: this.varietyObservationObject.percentage_of_planted_area,
        production: this.varietyObservationObject.production,
        comment: this.varietyObservationObject.comment,
        date: this.varietyObservationObject.date,
        effort: this.varietyObservationObject.effort,
        location_lat: this.varietyObservationObject.location_lat,
        location_lon: this.varietyObservationObject.location_lon,
        address: this.varietyObservationObject.address,
        pictures: this.varietyObservationObject.pictures,
        existing_household_id: this.varietyObservationObject.existing_household_id,
        household: _household,
      };

      this.observationService.putVarScoutObservation(_variety_selectedPut, _varietyObservationScoutPut).subscribe(
        (_resp) => {
          if (_resp.success) {
            // this.router.navigate(["/tablero/explorer-list-edit"]);

            this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
              this.router.navigate(["/tablero/explorer-list-edit"]).then(() => {
              })
            })
          } else {
            // error
          }
        }
      );

    } else {
      // create a new observation
      const _farmer = {
        // growers_name: this.varietyObservationObject.household.growers_name,
        farmer_name: this.varietyObservationObject.household.growers_name,
        age: this.varietyObservationObject.household.age ? this.varietyObservationObject.household.age : 0,
        sex: this.varietyObservationObject.household.sex,
        full_farm_area: this.varietyObservationObject.household.full_farm_area,
        // full_farm_area_unit: this.varietyObservationObject.household.full_farm_area_unit,
        full_farm_area_unit: this.varietyObservationObject.estimated_planted_area_unit,
        // anonymized: this.varietyObservationObject.household.anonymized,
        anonymized: false,
      };

      const _varietyObservationScoutNew = {
        address: this.varietyObservationObject.address,
        effort: this.varietyObservationObject.effort,
        estimated_planted_area: this.varietyObservationObject.estimated_planted_area,
        estimated_planted_area_unit: this.varietyObservationObject.estimated_planted_area_unit,
        planted_area_percentage: this.varietyObservationObject.percentage_of_planted_area,
        // images: [],
        images: this.varietyObservationObject.pictures,
        production: this.varietyObservationObject.production,
        observation_notes: this.varietyObservationObject.comment,
        observation_date: this.varietyObservationObject.date,
        // crop: "8edba93e-9b8e-11eb-823e-367cc97e1c10",
        // crop: this.varietyObservationObject.crop,
        variety_id: this.variety_id,
        // location_lat: this.varietyObservationObject.location_lat,
        latitude: this.varietyObservationObject.location_lat,
        // location_lon: this.varietyObservationObject.location_lon,
        longitude: this.varietyObservationObject.location_lon,
        farmer: this.farmer_id ? _farmer : null,
        farmer_id: this.farmer_id ? this.farmer_id : null,
      };

      if (this.variety_id && this.varietyObservationObject.effort) {
        this.observationService.createVarScoutObservation(_varietyObservationScoutNew).subscribe(
          (_resp) => {
            if (_resp.success) {
              // this.router.navigate(["/tablero/explorer-list-edit"]);

              this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                this.router.navigate(["/tablero/explorer-list-edit"]).then(() => {
                })
              })
            } else {
              // error
            }
          }
        );
      } else {

        if (this.variety_id == null && this.varietyObservationObject.effort == null) {
          this.has_error_1 = true;
          this.has_error_2 = true;
        } else if (this.variety_id == null) {
          this.has_error_1 = true;
        } else if (this.varietyObservationObject.effort == null) {
          this.has_error_2 = true;
        }
      }



    }
  }

  dateChange($event: any) {
    this.varietyObservationObject.date = $event.value.toISOString().slice(0, 10);
  }

  // variety information
  fnOpenDialog(): void {
    const _width = '900';
    if (this.variety_id) {
      const _dialogRef = this.dialog.open(DialogDetailsComponent, {
        width: _width + "px",
        data: { variety_id: this.variety_id },
      });
    }
  }

  // variety form
  fnOpenDialogForm(): void {
    const _width = '900';
    const _dialogRef = this.dialog.open(DialogFormVarietyComponent, {
      width: _width + "px",
      data: null,
    });
    _dialogRef.afterClosed().subscribe((_result: any) => {
      if (_result) {

        const _var = {
          page: 0,
          page_size: 1,
          variety_name: _result.variety_name,
          country: null,
          region: null,
          varietal_group: null,
          original_only: false,
          is_original: null,
          user_id: null,
          created_date: null,
        };

        this.varietyService.getSearch(_var).subscribe((_obj: any) => {
          _obj.data.map((_data: any) => {
            const _varietyItem = {
              variety: _data.vs_id,
              variety_name: _data.variety_name,
              variety_id: _data.variety_id
            };
            this.varietyControl.setValue(_varietyItem);
            this.varietyObservationObject.variety = _varietyItem.variety;
            this.varietyObservationObject.variety_name = _varietyItem.variety_name;
            this.variety_id = _varietyItem.variety_id;
          });
        });
      }
    });
  }

  selectVariety($event: any) {
    const _obj = $event.option.value;
    this.varietyObservationObject.variety = _obj.variety;
    this.varietyObservationObject.variety_name = _obj.variety_name;
    this.variety_id = _obj.variety_id;
  }

}
